import { createFileRoute, notFound } from "@tanstack/react-router"
import { CHARACTERS, type CharacterType } from "@/entities/characters"
import { CharacterBoardPage } from "@/pages/board"

export const Route = createFileRoute(
	"/_authenticated/board/character/$character",
)({
	params: {
		parse: (raw) => {
			const character = raw.character as CharacterType
			if (!CHARACTERS.includes(character)) throw notFound()
			return { character }
		},
		stringify: (parsed) => ({ character: parsed.character }),
	},
	component: CharacterBoardPageWrapper,
})

function CharacterBoardPageWrapper() {
	const { character } = Route.useParams()
	return <CharacterBoardPage character={character} />
}
